import React from 'react';

export default function Breadcrumb({ children }) {
    return (
        <ul className="breadcrumb breadcrumb-transparent breadcrumb-dot font-weight-bold p-0 my-2 ml-2 font-size-sm">
            {children}
        </ul>
    )
}